// extracted by mini-css-extract-plugin
export default {"ranger":"AllCertification_ranger__umBT1","col":"AllCertification_col__ks5tk","col_bg":"AllCertification_col_bg__lQR8A"};